/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {Track} from '@/models/scenario/track';
import {TrackIngress} from './track.ingress';
import {DecisionPoint} from '@/models/scenario/decision.point';
import {Train} from '@/models/scenario/train';
import {TrainDirection} from "@/models/scenario/train.class";
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class TrackRenderer
 *
 * @brief cell rendering for the diversions entry/exit tracks
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2020
 *
 */
export class TrackRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** the value being rendered */
  public value: TrackIngress;

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    this.gui           = document.createElement('div');
    this.gui.innerHTML = `<span style="color: grey;">M0</span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    if (typeof params.value === 'undefined') {

      /* grouping row */

      this.gui.innerHTML = `<span></span>`;
      return true;
    }

    this.value = params?.value;

    if (!this.value || !this.value.track) {

      this.gui.innerHTML = `<span style="color: grey;">M0</span>`;
      return ;
    }

    let label: string = `${this.value.track._id} ${Track.typeToString(this.value.track._type)}${this.value.track._track}`;

    if ('train' in params) {

      /*
       * in browsers/editors where we have access to a train / start / end, we can use the
       * train direction to show the direction of mileage implied by this track.
       *
       */

      /* find the train (so we have direction of travel) */

      // @ts-ignore
      const   train: Train    = params.train(params.data.id);
      const mileage: number[] = [];

      /* find the mileage at either end of the track (one may be null if Junction or end of network) */

      [
        this.value.track._after,
        this.value.track._before
      ].filter(x => x !== null).forEach((x: DecisionPoint) => {

        mileage.push(x._mileage);
      });

      /* make the lower mileage first */

      mileage.sort();

      if (train._tc._dir === TrainDirection.EAST) {

        /* show east bound travel ... */

        label  = '';

        let lhs: number = mileage[0];

        if (mileage.length === 2) {

          lhs = mileage[1];
        }

        label += '<span style="color: grey;">';
        label += `(${this.value.track._id}) `;
        label += `${lhs}`;
        label += ' \u2192 ';
        label += '</span>';

        label += `<span style="color: white;">${Track.typeToString(this.value.track._type)}${this.value.track._track}</span>`;;

        if (mileage.length === 2) {

          label += '<span style="color: grey;">';
          label += ' \u2192 ';
          label += `${mileage[0]}`;
          label += '</span>';
        }

      } else {

        /* show west bound travel ... */

        label  = '';

        label += '<span style="color: grey;">';
        label += `(${this.value.track._id}) `;
        label += `${mileage[0]}`;
        label += ' \u2190 ';
        label += '</span>';

        label += `<span style="color: white;">${Track.typeToString(this.value.track._type)}${this.value.track._track}</span>`;;

        if (mileage.length === 2) {

          label += '<span style="color: grey;">';
          label += ' \u2190 ';
          label += `${mileage[1]}`;
          label += '</span>';
        }

      }

    }

    /* render the label */

    this.gui.innerHTML = `<span style="color: white;">${label}</span>`;

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
